const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  page:  state => state.user.page,
  loading: state => state.app.loading,
  tips: state => state.app.tips,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  buttons: state => state.user.buttons,
  userId: state => state.user.userId,
  nav_type: state => state.user.nav_type,
  rowData: state => state.rowData,
  uploadFilestatus: state => state.uploadFile.uploadFilestatus,
  uploadFileInfo: state => state.uploadFile.uploadFileInfo,
}

export default getters